import React, { useState, useEffect } from 'react';
import './AdminPanel.css';
import BirthdayManager from './BirthdayManager';
import TelegramTest from './TelegramTest';

// Kapsamlı ReportsView bileşeni
function ReportsView({ students, behaviors = {}, behaviorIssues = [], economy = {} }) {
  const [reportType, setReportType] = useState('overview');
  const [showTotalViolations, setShowTotalViolations] = useState(false);
  const today = new Date().toISOString().split('T')[0];
  
  // Analytics hesaplamaları
  const getAnalytics = () => {
    const analytics = {
      totalStudents: students?.length || 0,
      totalBehaviorRecords: Object.keys(behaviors || {}).length,
      totalEconomyRecords: Object.keys(economy || {}).length
    };
    
    // Davranış istatistikleri (tüm davranışlar dahil)
    let totalBehaviorIssues = 0;
    Object.values(behaviors || {}).forEach(count => totalBehaviorIssues += count);
    analytics.totalBehaviorIssues = totalBehaviorIssues;
    analytics.behaviorAverage = students?.length > 0 ? (totalBehaviorIssues / students.length).toFixed(1) : 0;
    
    // Ekonomi istatistikleri
    let totalEarnings = 0, totalSpending = 0;
    (students || []).forEach(student => {
      totalEarnings += (economy || {})[`earnings-${student.id}`] || 0;
      totalSpending += (economy || {})[`spending-${student.id}`] || 0;
    });
    analytics.totalEarnings = totalEarnings;
    analytics.totalSpending = totalSpending;
    analytics.averageBalance = students?.length > 0 ? ((totalEarnings - totalSpending) / students.length).toFixed(1) : 0;
    
    return analytics;
  };
  
  const getTopPerformers = () => {
    return (students || []).map(student => {
      
      // Davranış ceza hesaplama
      let behaviorPenalty = 0;
      const customBehaviors = JSON.parse(localStorage.getItem('customBehaviors') || '[]');
      const allBehaviors = [...(behaviorIssues || []), ...customBehaviors.filter(cb => !(behaviorIssues || []).find(bi => bi.code === cb.code))];
      
      Object.keys(behaviors || {}).forEach(key => {
        if (key.startsWith(`${student.id}-`)) {
          const parts = key.split('-');
          const behaviorCode = parts[1];
          const count = (behaviors || {})[key] || 0;
          
          const behavior = allBehaviors.find(b => b.code === behaviorCode);
          if (behavior && count > 0) {
            let penalty = 0;
            switch(behavior.code) {
              case 'D01': penalty = count * 10; break;
              case 'D02': penalty = count * 8; break;
              case 'D03': penalty = count * 5; break;
              default: 
                const customBehavior = customBehaviors.find(cb => cb.code === behavior.code);
                penalty = count * (customBehavior?.penalty || 3);
                break;
            }
            behaviorPenalty += penalty;
          }
        }
      });
      
      // Öğretmen ödülü
      const teacherReward = (economy || {})[`earnings-${student.id}`] || 0;
      
      // Toplam para
      const totalMoney = teacherReward - behaviorPenalty;
      

      
      // Bugünkü davranış sayısı
      let todayBehaviorCount = 0;
      allBehaviors.forEach(behavior => {
        const key = `${student.id}-${behavior.code}-${today}`;
        todayBehaviorCount += (behaviors || {})[key] || 0;
      });
      
      return {
        ...student,
        behaviorCount: todayBehaviorCount,
        totalMoney,
        score: totalMoney
      };
    }).sort((a, b) => b.totalMoney - a.totalMoney);
  };
  
  const getBehaviorAnalysis = () => {
    const todayAnalysis = {};
    const totalAnalysis = {};
    
    // Default davranışları ekle
    (behaviorIssues || []).forEach(behavior => {
      todayAnalysis[behavior.code] = {
        description: behavior.description,
        count: 0,
        students: []
      };
      totalAnalysis[behavior.code] = {
        description: behavior.description,
        count: 0,
        students: []
      };
    });
    
    // Custom davranışları ekle
    const customBehaviors = JSON.parse(localStorage.getItem('customBehaviors') || '[]');
    customBehaviors.forEach(behavior => {
      if (!todayAnalysis[behavior.code]) {
        todayAnalysis[behavior.code] = {
          description: behavior.description,
          count: 0,
          students: []
        };
        totalAnalysis[behavior.code] = {
          description: behavior.description,
          count: 0,
          students: []
        };
      }
    });
    
    // Tüm davranışları analiz et
    const allBehaviors = [...(behaviorIssues || []), ...customBehaviors.filter(cb => !(behaviorIssues || []).find(bi => bi.code === cb.code))];
    
    (students || []).forEach(student => {
      allBehaviors.forEach(behavior => {
        // Bugünkü davranışlar
        const todayKey = `${student.id}-${behavior.code}-${today}`;
        const todayCount = (behaviors || {})[todayKey] || 0;
        if (todayCount > 0) {
          todayAnalysis[behavior.code].count += todayCount;
          todayAnalysis[behavior.code].students.push({ name: student.name, count: todayCount });
        }
        
        // Tüm davranışlar (tüm tarihler)
        Object.keys(behaviors || {}).forEach(key => {
          if (key.startsWith(`${student.id}-${behavior.code}-`)) {
            const count = (behaviors || {})[key] || 0;
            if (count > 0) {
              const existingStudent = totalAnalysis[behavior.code].students.find(s => s.name === student.name);
              if (existingStudent) {
                existingStudent.count += count;
              } else {
                totalAnalysis[behavior.code].students.push({ name: student.name, count });
              }
              totalAnalysis[behavior.code].count += count;
            }
          }
        });
      });
    });
    
    return {
      today: Object.entries(todayAnalysis)
        .filter(([_, data]) => data.count > 0)
        .sort(([_, a], [__, b]) => b.count - a.count),
      total: Object.entries(totalAnalysis)
        .filter(([_, data]) => data.count > 0)
        .sort(([_, a], [__, b]) => b.count - a.count)
    };
  };
  

  
  const analytics = getAnalytics();
  const topPerformers = getTopPerformers();
  const behaviorAnalysis = getBehaviorAnalysis();
  
  return (
    <div className="reports-view">
      <h2>📈 Gelişmiş Raporlama</h2>
      
      <div className="report-tabs">
        <button className={`report-tab ${reportType === 'overview' ? 'active' : ''}`} onClick={() => setReportType('overview')}>
          📈 Genel Bakış
        </button>

        <button className={`report-tab ${reportType === 'behavior' ? 'active' : ''}`} onClick={() => setReportType('behavior')}>
          ⭐ Davranış Analizi
        </button>
        <button className={`report-tab ${reportType === 'economy' ? 'active' : ''}`} onClick={() => setReportType('economy')}>
          💰 Ekonomi Analizi
        </button>
      </div>
      
      {reportType === 'overview' && (
        <div className="report-section">
          <h3>📈 Sınıf Genel Durumu</h3>
          
          <div className="analytics-grid">
            <div className="analytics-card">
              <h4>👥 Öğrenci Sayısı</h4>
              <div className="big-number">{analytics.totalStudents}</div>
            </div>

            <div className="analytics-card">
              <h4>⭐ Davranış Ortalaması</h4>
              <div className="big-number">{analytics.behaviorAverage}</div>
            </div>
            <div className="analytics-card">
              <h4>💰 Ortalama Bakiye</h4>
              <div className="big-number">{analytics.averageBalance}₺</div>
            </div>
          </div>
          
          <div className="top-performers">
            <h4>🏆 Top 10 - En Başarılı Öğrenciler</h4>
            <div className="performers-list">
              {topPerformers.slice(0, 10).map((student, index) => {
                const rankEmoji = index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : '🏅';
                const rankClass = index < 3 ? 'podium' : 'regular';
                
                return (
                  <div key={student.id} className={`performer-item ${rankClass}`}>
                    <span className="rank">{index + 1}. {rankEmoji}</span>
                    <span className="name">{student.name}</span>
                    <span className="stats">
                      Davranış: {student.behaviorCount} | Para: {student.totalMoney}₺
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      

      
      {reportType === 'behavior' && (
        <div className="report-section">
          <h3>⭐ Davranış Analizi</h3>
          
          <div className="behavior-stats">
            <div className="behavior-summary">
              <div className="summary-card">
                <h4>Toplam İhlal</h4>
                <div className="big-number">{analytics.totalBehaviorIssues}</div>
              </div>
              <div className="summary-card">
                <h4>Temiz Öğrenci</h4>
                <div className="big-number">
                  {(students || []).filter(student => {
                    const customBehaviors = JSON.parse(localStorage.getItem('customBehaviors') || '[]');
                    const allBehaviors = [...(behaviorIssues || []), ...customBehaviors.filter(cb => !(behaviorIssues || []).find(bi => bi.code === cb.code))];
                    return allBehaviors.every(behavior => {
                      const key = `${student.id}-${behavior.code}-${today}`;
                      return ((behaviors || {})[key] || 0) === 0;
                    });
                  }).length}
                </div>
              </div>
            </div>
            
            <div className="behavior-breakdown">
              <h4>📅 Bugünkü İhlaller</h4>
              {behaviorAnalysis.today.length > 0 ? (
                behaviorAnalysis.today.map(([code, data]) => (
                  <div key={code} className="behavior-item today">
                    <div className="behavior-header">
                      <span className="behavior-code">{code}</span>
                      <span className="behavior-count">{data.count} kez</span>
                    </div>
                    <p className="behavior-desc">{data.description}</p>
                    <div className="affected-students">
                      {data.students.map(student => (
                        <span key={student.name} className="student-tag">
                          {student.name} ({student.count})
                        </span>
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-violations">
                  <p>🎉 Bugün hiç ihlal yok! Harikasınız Çocuklar!</p>
                </div>
              )}
              
              <div className="total-violations-section" style={{marginTop: '30px'}}>
                <h4 
                  className="collapsible-header" 
                  onClick={() => setShowTotalViolations(!showTotalViolations)}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '5px',
                    border: '1px solid #dee2e6'
                  }}
                >
                  <span>{showTotalViolations ? '▼' : '▶'}</span>
                  📊 Kuralları İhlal Edenler Tüm Zamanlar - {behaviorAnalysis.total.length} tür
                </h4>
                
                {showTotalViolations && (
                  <div className="total-violations-content" style={{marginTop: '10px'}}>
                    {behaviorAnalysis.total.map(([code, data]) => (
                      <div key={code} className="behavior-item total">
                        <div className="behavior-header">
                          <span className="behavior-code">{code}</span>
                          <span className="behavior-count">{data.count} kez</span>
                        </div>
                        <p className="behavior-desc">{data.description}</p>
                        <div className="affected-students">
                          {data.students.map(student => (
                            <span key={student.name} className="student-tag">
                              {student.name} ({student.count})
                            </span>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      
      {reportType === 'economy' && (
        <div className="report-section">
          <h3>💰 Ekonomi Analizi</h3>
          
          <div className="economy-stats">
            <div className="economy-summary">
              <div className="summary-card">
                <h4>Toplam Kazanç</h4>
                <div className="big-number">{analytics.totalEarnings}₺</div>
              </div>
              <div className="summary-card">
                <h4>Toplam Harcama</h4>
                <div className="big-number">{analytics.totalSpending}₺</div>
              </div>
              <div className="summary-card">
                <h4>Net Bakiye</h4>
                <div className="big-number">{analytics.totalEarnings - analytics.totalSpending}₺</div>
              </div>
            </div>
            
            <div className="wealth-distribution">
              <h4>Zenginlik Dağılımı</h4>
              <div className="wealth-list">
                {topPerformers.slice(0, 10).map((student, index) => (
                  <div key={student.id} className="wealth-item">
                    <span className="rank">#{index + 1}</span>
                    <span className="name">{student.name}</span>
                    <span className="money">{student.totalMoney}₺</span>
                    <div className="money-bar">
                      <div 
                        className="bar" 
                        style={{ 
                          width: `${Math.max(0, (student.totalMoney / Math.max(...topPerformers.map(s => s.totalMoney))) * 100)}%`,
                          backgroundColor: student.totalMoney >= 0 ? '#27ae60' : '#e74c3c'
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Unit name normalization fonksiyonu
const normalizeUnitName = (name = "") =>
  name
    .replace(/\(.*?\)/g, "")     // Parantez içindeki tarih bilgisini sil
    .split(/\n|\\n/)[0]          // Hem gerçek \n, hem string "\\n" varsa ilk kısmı al
    .trim();                     // Baştaki/sondaki boşlukları sil

const AdminPanel = ({ students, behaviors, behaviorIssues, economy, onClose, onUpdateStudents, curriculum, onUpdateCurriculum }) => {
  const [activeTab, setActiveTab] = useState('students');
  const [manualSendStatus, setManualSendStatus] = useState('');
  const [lastManualSend, setLastManualSend] = useState({ daily: null, weekly: null });

  const [studentForm, setStudentForm] = useState({
    name: '',
    schoolNumber: '',
    parentTelegram: '',
    parentName: ''
  });
  const [editingStudent, setEditingStudent] = useState(null);

  const [behaviorForm, setBehaviorForm] = useState({ code: '', description: '', penalty: 3, type: 'daily_count' });
  const [editingBehavior, setEditingBehavior] = useState(null);
  const [behaviorForceUpdate, setBehaviorForceUpdate] = useState(0);

  const handleAddStudent = () => {
    if (!studentForm.name || !studentForm.schoolNumber) {
      alert('Ad ve okul numarası zorunludur!');
      return;
    }

    const newStudent = {
      id: Date.now().toString(),
      name: studentForm.name,
      schoolNumber: studentForm.schoolNumber,
      parentTelegram: studentForm.parentTelegram,
      parentName: studentForm.parentName
    };

    const updatedStudents = [...students, newStudent];
    onUpdateStudents(updatedStudents);
    setStudentForm({ name: '', schoolNumber: '', parentTelegram: '', parentName: '' });
    alert('Öğrenci başarıyla eklendi!');
  };

  const handleEditStudent = (student) => {
    setEditingStudent(student.id);
    setStudentForm({
      name: student.name,
      schoolNumber: student.schoolNumber || student.school_number || '',
      parentTelegram: student.parentTelegram || student.parent_telegram || '',
      parentName: student.parentName || student.parent_name || ''
    });
  };

  const handleUpdateStudent = () => {
    const updatedStudents = students.map(student =>
      student.id === editingStudent
        ? { 
            ...student, 
            name: studentForm.name,
            schoolNumber: studentForm.schoolNumber,
            school_number: studentForm.schoolNumber,
            parentTelegram: studentForm.parentTelegram,
            parent_telegram: studentForm.parentTelegram,
            parentName: studentForm.parentName,
            parent_name: studentForm.parentName
          }
        : student
    );
    onUpdateStudents(updatedStudents);
    setEditingStudent(null);
    setStudentForm({ name: '', schoolNumber: '', parentTelegram: '', parentName: '' });
    alert('Öğrenci bilgileri güncellendi!');
  };

  const handleDeleteStudent = (studentId) => {
    if (window.confirm('Bu öğrenciyi silmek istediğinizden emin misiniz?')) {
      const updatedStudents = students.filter(student => student.id !== studentId);
      onUpdateStudents(updatedStudents);
      alert('Öğrenci silindi!');
    }
  };







  const exportData = () => {
    // localStorage'dan güncel müfredat verilerini al
    const localCurriculum = JSON.parse(localStorage.getItem('curriculum') || 'null');
    const finalCurriculum = localCurriculum || curriculum;
    
    const data = {
      // AdminPanel verileri
      students,
      curriculum: finalCurriculum, // localStorage'dan güncel müfredat
      
      // Akıllı tahta verileri
      behaviors,
      economy,
      
      // localStorage'dan özel veriler
      customBehaviors: JSON.parse(localStorage.getItem('customBehaviors') || '[]'),
      weeklyTests: JSON.parse(localStorage.getItem('weeklyTests') || '[]'),
      
      // Mağaza alışveriş geçmişi
      purchaseHistory: JSON.parse(localStorage.getItem('purchaseHistory') || '[]'),
      
      // Doğum günü bilgileri
      studentBirthdays: JSON.parse(localStorage.getItem('studentBirthdays') || '[]'),
      
      // Yedek bilgileri
      exportDate: new Date().toISOString(),
      backupType: 'FULL_SYSTEM_BACKUP',
      version: '2.0'
    };
    
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `tam-sistem-yedeği-${new Date().toISOString().split('T')[0]}.json`;
    a.click();
  };

  const importData = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = JSON.parse(e.target.result);
        
        // Yeni tam sistem yedeği (v2.0)
        if (data.backupType === 'FULL_SYSTEM_BACKUP' && data.students && data.curriculum) {
          // AdminPanel verilerini yükle
          onUpdateStudents(data.students);
          onUpdateCurriculum(data.curriculum);
          
          // Akıllı tahta verilerini localStorage'a yükle - Ana objeleri kaydet
          if (data.behaviors) {
            localStorage.setItem('behaviors', JSON.stringify(data.behaviors));
          }
          if (data.economy) {
            localStorage.setItem('economy', JSON.stringify(data.economy));
          }
          if (data.customBehaviors) {
            localStorage.setItem('customBehaviors', JSON.stringify(data.customBehaviors));
          }
          if (data.customAchievements) {
            localStorage.setItem('customAchievements', JSON.stringify(data.customAchievements));
          }
          if (data.weeklyTests) {
            localStorage.setItem('weeklyTests', JSON.stringify(data.weeklyTests));
          }
          if (data.purchaseHistory) {
            localStorage.setItem('purchaseHistory', JSON.stringify(data.purchaseHistory));
          }
          if (data.studentBirthdays) {
            localStorage.setItem('studentBirthdays', JSON.stringify(data.studentBirthdays));
          }
          
          alert('Tam sistem yedeği başarıyla yüklendi! Sayfa yenileniyor...');
          setTimeout(() => window.location.reload(), 1500);
        }
        // Eski AdminPanel formatı (sadece students + curriculum)
        else if (data.students && data.curriculum && !data.backupType) {
          onUpdateStudents(data.students);
          onUpdateCurriculum(data.curriculum);
          alert('AdminPanel yedeği başarıyla yüklendi!');
        }
        // Eski akıllı tahta formatı
        else if (data.behaviors || data.economy) {
          // Akıllı tahta verilerini localStorage'a yükle - Ana objeleri kaydet
          if (data.behaviors) {
            localStorage.setItem('behaviors', JSON.stringify(data.behaviors));
          }
          if (data.economy) {
            localStorage.setItem('economy', JSON.stringify(data.economy));
          }
          if (data.customBehaviors) {
            localStorage.setItem('customBehaviors', JSON.stringify(data.customBehaviors));
          }
          if (data.customAchievements) {
            localStorage.setItem('customAchievements', JSON.stringify(data.customAchievements));
          }
          if (data.weeklyTests) {
            localStorage.setItem('weeklyTests', JSON.stringify(data.weeklyTests));
          }
          if (data.purchaseHistory) {
            localStorage.setItem('purchaseHistory', JSON.stringify(data.purchaseHistory));
          }
          if (data.studentBirthdays) {
            localStorage.setItem('studentBirthdays', JSON.stringify(data.studentBirthdays));
          }
          
          alert('Akıllı tahta yedeği başarıyla yüklendi! Sayfa yenileniyor...');
          setTimeout(() => window.location.reload(), 1500);
        }
        else {
          alert('Geçersiz dosya formatı! Desteklenen formatlar:\n- Tam sistem yedeği (v2.0)\n- AdminPanel yedeği (students + curriculum)\n- Akıllı tahta yedeği (behaviors + economy)');
        }
      } catch (error) {
        alert('Dosya okuma hatası: ' + error.message);
      }
    };
    reader.readAsText(file);
  };

  // Veri yönetimi fonksiyonları
  const syncLocalStorageToSupabase = async () => {
    const evalKeys = Object.keys(localStorage).filter(key => key.startsWith('eval_'));
    const behaviorKeys = Object.keys(localStorage).filter(key => key.startsWith('behavior_'));
    let evalSyncCount = evalKeys.length;
    let behaviorSyncCount = behaviorKeys.length;
    
    const totalSynced = evalSyncCount + behaviorSyncCount;
    if (totalSynced > 0) {
      setManualSendStatus(`${evalSyncCount} akademik, ${behaviorSyncCount} davranış kaydı senkronize edildi.`);
      setTimeout(() => setManualSendStatus(''), 3000);
    } else {
      setManualSendStatus('Senkronize edilecek veri bulunamadı.');
      setTimeout(() => setManualSendStatus(''), 3000);
    }
  };

  const resetTestStudentData = async () => {
    const testStudent = students?.find(s => s.school_number === 'TEST' || s.schoolNumber === 'TEST');
    if (!testStudent) {
      setManualSendStatus('TEST öğrencisi bulunamadı.');
      setTimeout(() => setManualSendStatus(''), 3000);
      return;
    }

    const confirmed = window.confirm(
      `TEST öğrencisi (${testStudent.name}) için tüm verileri sıfırlamak istediğinizden emin misiniz?\n\n- Tüm değerlendirmeler\n- Tüm davranış kayıtları\n- Tüm bildirimler\n\nBu işlem geri alınamaz!`
    );
    
    if (!confirmed) return;

    try {
      const evalKeys = Object.keys(localStorage).filter(key => 
        key.startsWith('eval_') && key.includes(`_${testStudent.id}_`)
      );
      const behaviorKeys = Object.keys(localStorage).filter(key => 
        key.startsWith('behavior_') && key.includes(`_${testStudent.id}_`)
      );
      const economyKeys = Object.keys(localStorage).filter(key => 
        key.startsWith('economy_') && key.includes(`${testStudent.id}`)
      );
      
      [...evalKeys, ...behaviorKeys, ...economyKeys].forEach(key => localStorage.removeItem(key));
      
      setManualSendStatus(`TEST öğrencisi verileri temizlendi: ${evalKeys.length} değerlendirme, ${behaviorKeys.length} davranış`);
      setTimeout(() => setManualSendStatus(''), 5000);
      
    } catch (error) {
      console.error('Reset error:', error);
      setManualSendStatus('Veri sıfırlama hatası.');
      setTimeout(() => setManualSendStatus(''), 3000);
    }
  };

  const resetAllSystemData = async () => {
    const evalKeys = Object.keys(localStorage).filter(key => key.startsWith('eval_'));
    const mainEvals = JSON.parse(localStorage.getItem('evaluations') || '{}');
    const behaviorKeys = Object.keys(localStorage).filter(key => key.startsWith('behavior_'));
    const mainBehaviors = JSON.parse(localStorage.getItem('behaviors') || '{}');
    const economyKeys = Object.keys(localStorage).filter(key => key.startsWith('economy_'));
    const mainEconomy = JSON.parse(localStorage.getItem('economy') || '{}');
    
    const evalCount = evalKeys.length + Object.keys(mainEvals).length;
    
    // Davranış olay sayısını hesapla
    let behaviorEventCount = 0;
    behaviorKeys.forEach(key => {
      behaviorEventCount += parseInt(localStorage.getItem(key)) || 0;
    });
    Object.values(mainBehaviors).forEach(count => {
      behaviorEventCount += count || 0;
    });
    
    const economyCount = economyKeys.length + Object.keys(mainEconomy).length;
    
    const confirmed = window.confirm(
      `TÜM SİSTEM VERİLERİNİ SİFIRLA\n\nSilinecek veriler:\n- Akademik: ${evalCount} kayıt\n- Davranış: ${behaviorEventCount} olay\n- Ekonomi: ${economyCount} kayıt\n\nKorunacak:\n- Öğrenci listesi\n- Doğum günü bilgileri\n\nDevam etmek istediğinizden emin misiniz?`
    );
    
    if (!confirmed) return;

    const finalConfirm = window.confirm(
      'SON UYARI: Bu işlem geri alınamaz!\n\nTüm geçmiş veriler silinecek ve sistem ilk gün gibi temizlenecek.\n\nEmin misiniz?'
    );
    
    if (!finalConfirm) return;

    try {
      setManualSendStatus('Sistem verileri temizleniyor...');
      
      // Doğum günü verilerini koru
      const studentBirthdays = localStorage.getItem('studentBirthdays');
      
      // localStorage tamamen temizle
      localStorage.clear();
      
      // Doğum günü verilerini geri yükle
      if (studentBirthdays) {
        localStorage.setItem('studentBirthdays', studentBirthdays);
      }
      
      // Cache temizle
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => {
            caches.delete(name);
          });
        });
      }
      
      // Akıllı tahtayı bilgilendir
      if (window.opener) {
        window.opener.postMessage({ type: 'RELOAD_REQUIRED' }, '*');
      }
      
      setManualSendStatus('Sistem başarıyla temizlendi. Sayfa yenileniyor...');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      
    } catch (error) {
      console.error('System reset error:', error);
      setManualSendStatus('Sistem temizleme hatası: ' + error.message);
      setTimeout(() => setManualSendStatus(''), 5000);
    }
  };

  const clearAllEvaluations = async () => {
    const localStorageKeys = Object.keys(localStorage).filter(key => key.startsWith('eval_'));
    const mainEvals = JSON.parse(localStorage.getItem('evaluations') || '{}');
    const localStorageCount = localStorageKeys.length + Object.keys(mainEvals).length;
    
    const firstConfirm = window.confirm(
      `Tüm akademik değerlendirmeleri silmek istediğinizden emin misiniz?\n\nSilinecek kayıtlar: ${localStorageCount} adet\n\nBu işlem geri alınamaz!`
    );
    
    if (!firstConfirm) return;

    try {
      setManualSendStatus('Değerlendirmeler temizleniyor...');
      
      // localStorage'dan sil
      localStorageKeys.forEach(key => {
        localStorage.removeItem(key);
      });
      
      // Ana evaluations objesini de temizle
      localStorage.removeItem('evaluations');
      
      // Akıllı tahtayı bilgilendir
      if (window.opener) {
        window.opener.postMessage({ type: 'RELOAD_REQUIRED' }, '*');
      }
      
      setManualSendStatus(`${localStorageCount} akademik değerlendirme başarıyla silindi. Sayfa yenileniyor...`);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      
    } catch (error) {
      console.error('Clear evaluations error:', error);
      setManualSendStatus('Silme işlemi sırasında hata oluştu: ' + error.message);
      setTimeout(() => setManualSendStatus(''), 3000);
    }
  };

  const clearAllBehaviors = async () => {
    const behaviorKeys = Object.keys(localStorage).filter(key => key.startsWith('behavior_'));
    const mainBehaviors = JSON.parse(localStorage.getItem('behaviors') || '{}');
    
    // Toplam olay sayısını hesapla (anasayfa ile aynı mantık)
    let totalBehaviorEvents = 0;
    behaviorKeys.forEach(key => {
      totalBehaviorEvents += parseInt(localStorage.getItem(key)) || 0;
    });
    Object.values(mainBehaviors).forEach(count => {
      totalBehaviorEvents += count || 0;
    });
    
    const firstConfirm = window.confirm(
      `Tüm davranış verilerini silmek istediğinizden emin misiniz?\n\nSilinecek davranış olayları: ${totalBehaviorEvents} adet\n\nBu işlem geri alınamaz!`
    );
    
    if (!firstConfirm) return;

    try {
      setManualSendStatus('Davranış kayıtları temizleniyor...');
      
      // localStorage'dan sil
      behaviorKeys.forEach(key => {
        localStorage.removeItem(key);
      });
      
      // Ana behaviors objesini de temizle
      localStorage.removeItem('behaviors');
      
      // Akıllı tahtayı bilgilendir
      if (window.opener) {
        window.opener.postMessage({ type: 'RELOAD_REQUIRED' }, '*');
      }
      
      setManualSendStatus(`${totalBehaviorEvents} davranış olayı başarıyla silindi. Sayfa yenileniyor...`);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      
    } catch (error) {
      console.error('Clear behaviors error:', error);
      setManualSendStatus('Davranış silme işlemi sırasında hata oluştu: ' + error.message);
      setTimeout(() => setManualSendStatus(''), 3000);
    }
  };

  const clearAllEconomy = async () => {
    const economyKeys = Object.keys(localStorage).filter(key => key.startsWith('economy_'));
    const mainEconomy = JSON.parse(localStorage.getItem('economy') || '{}');
    const economyCount = economyKeys.length + Object.keys(mainEconomy).length;
    
    const firstConfirm = window.confirm(
      `Tüm ekonomi verilerini silmek istediğinizden emin misiniz?\n\nSilinecek kayıtlar: ${economyCount} adet\n\nBu işlem geri alınamaz!`
    );
    
    if (!firstConfirm) return;

    try {
      setManualSendStatus('Ekonomi kayıtları temizleniyor...');
      
      // localStorage'dan sil
      economyKeys.forEach(key => {
        localStorage.removeItem(key);
      });
      
      // Ana economy objesini de temizle
      localStorage.removeItem('economy');
      
      // Akıllı tahtayı bilgilendir
      if (window.opener) {
        window.opener.postMessage({ type: 'RELOAD_REQUIRED' }, '*');
      }
      
      setManualSendStatus(`${economyCount} ekonomi kaydı başarıyla silindi. Sayfa yenileniyor...`);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      
    } catch (error) {
      console.error('Clear economy error:', error);
      setManualSendStatus('Ekonomi silme işlemi sırasında hata oluştu: ' + error.message);
      setTimeout(() => setManualSendStatus(''), 3000);
    }
  };

  return (
    <div className="admin-panel-overlay">
      <div className="admin-panel">
        <div className="admin-header">
          <h2>Yönetim Paneli</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="admin-tabs">
          <button 
            className={`tab-btn ${activeTab === 'students' ? 'active' : ''}`}
            onClick={() => setActiveTab('students')}
          >
            Öğrenci Yönetimi
          </button>
          <button 
            className={`tab-btn ${activeTab === 'birthdays' ? 'active' : ''}`}
            onClick={() => setActiveTab('birthdays')}
          >
            🎂 Doğum Günleri
          </button>

          <button 
            className={`tab-btn ${activeTab === 'behaviors' ? 'active' : ''}`}
            onClick={() => setActiveTab('behaviors')}
          >
            🔧 Davranış Yönetimi
          </button>
          <button 
            className={`tab-btn ${activeTab === 'datamanagement' ? 'active' : ''}`}
            onClick={() => setActiveTab('datamanagement')}
          >
            Sistem Yönetimi
          </button>
          <button 
            className={`tab-btn ${activeTab === 'reports' ? 'active' : ''}`}
            onClick={() => setActiveTab('reports')}
          >
            Gelişmiş Raporlama
          </button>
          <button 
            className={`tab-btn ${activeTab === 'telegram' ? 'active' : ''}`}
            onClick={() => setActiveTab('telegram')}
          >
            📱 Telegram Test
          </button>

        </div>

        <div className="admin-content">
          {activeTab === 'students' && (
            <div className="students-management">
              <div className="add-student-form">
                <h3>{editingStudent ? 'Öğrenci Düzenle' : 'Yeni Öğrenci Ekle'}</h3>
                <div className="form-grid">
                  <input
                    type="text"
                    placeholder="Öğrenci Adı"
                    value={studentForm.name}
                    onChange={(e) => setStudentForm({...studentForm, name: e.target.value})}
                  />
                  <input
                    type="text"
                    placeholder="Okul Numarası"
                    value={studentForm.schoolNumber}
                    onChange={(e) => setStudentForm({...studentForm, schoolNumber: e.target.value})}
                  />
                  <input
                    type="text"
                    placeholder="Veli Telegram (@kullanici_adi)"
                    value={studentForm.parentTelegram}
                    onChange={(e) => setStudentForm({...studentForm, parentTelegram: e.target.value})}
                  />
                  <input
                    type="text"
                    placeholder="Veli Adı"
                    value={studentForm.parentName}
                    onChange={(e) => setStudentForm({...studentForm, parentName: e.target.value})}
                  />
                </div>
                <div className="form-buttons">
                  {editingStudent ? (
                    <>
                      <button className="update-btn" onClick={handleUpdateStudent}>Güncelle</button>
                      <button className="cancel-btn" onClick={() => {
                        setEditingStudent(null);
                        setStudentForm({ name: '', schoolNumber: '', parentTelegram: '', parentName: '' });
                      }}>İptal</button>
                    </>
                  ) : (
                    <button className="add-btn" onClick={handleAddStudent}>Ekle</button>
                  )}
                </div>
              </div>

              <div className="students-list">
                <h3>Mevcut Öğrenciler ({students.length})</h3>
                <div className="students-grid">
                  {students.map((student) => (
                    <div key={student.id} className="student-card">
                      <div className="student-info">
                        <h4>{student.name}</h4>
                        <p>Numara: {student.schoolNumber || student.school_number || 'Belirtilmemiş'}</p>
                        <p>Veli: {student.parentName || student.parent_name || 'Belirtilmemiş'}</p>
                        <p>Telegram: {student.parentTelegram || student.parent_telegram || 'Belirtilmemiş'}</p>
                      </div>
                      <div className="student-actions">
                        <button className="edit-btn" onClick={() => handleEditStudent(student)}>Düzenle</button>
                        <button className="delete-btn" onClick={() => handleDeleteStudent(student.id)}>Sil</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}





          {activeTab === 'datamanagement' && (
            <div className="data-management">
              <div className="settings-section">
                <h3>Yedekleme İşlemleri</h3>
                <div className="settings-actions">
                  <button className="export-btn" onClick={exportData}>
                    💾 Tam Sistem Yedeği İndir
                  </button>
                  <label className="import-btn">
                    📁 Yedek Dosyası Yükle
                    <input
                      type="file"
                      accept=".json"
                      onChange={importData}
                      style={{ display: 'none' }}
                    />
                  </label>
                  <p style={{fontSize: '14px', color: '#666', marginTop: '10px'}}>
                    Tüm sistem verileri (AdminPanel + Akıllı Tahta) tek dosyada
                  </p>
                </div>
              </div>



              <div className="settings-section">
                <h3>Sistem Bilgileri</h3>
                <div className="system-info">
                  <p>👥 Toplam Öğrenci: {students.length}</p>
                  <p>📅 Son Güncelleme: {new Date().toLocaleDateString('tr-TR')}</p>
                  <p>📊 Mevcut Veriler: 
                    {(() => {
                      const behaviorKeys = Object.keys(localStorage).filter(key => key.startsWith('behavior_'));
                      const mainBehaviors = JSON.parse(localStorage.getItem('behaviors') || '{}');
                      let totalEvents = 0;
                      behaviorKeys.forEach(key => {
                        totalEvents += parseInt(localStorage.getItem(key)) || 0;
                      });
                      Object.values(mainBehaviors).forEach(count => {
                        totalEvents += count || 0;
                      });
                      return totalEvents;
                    })()} davranış olayı
                  </p>
                </div>
              </div>

              <div className="settings-section">
                <h3>Veri Temizleme</h3>
                <div className="settings-actions">

                  <div className="clear-item">
                    <button className="clear-btn" onClick={clearAllBehaviors}>
                      🗑️ Davranış Verilerini Sil
                    </button>
                    <span className="data-count">
                      {(() => {
                        const behaviorKeys = Object.keys(localStorage).filter(key => key.startsWith('behavior_'));
                        const mainBehaviors = JSON.parse(localStorage.getItem('behaviors') || '{}');
                        let totalEvents = 0;
                        behaviorKeys.forEach(key => {
                          totalEvents += parseInt(localStorage.getItem(key)) || 0;
                        });
                        Object.values(mainBehaviors).forEach(count => {
                          totalEvents += count || 0;
                        });
                        return totalEvents;
                      })()} olay
                    </span>
                  </div>
                  <div className="clear-item">
                    <button className="clear-btn" onClick={clearAllEconomy}>
                      🗑️ Ekonomi Verilerini Sil
                    </button>
                    <span className="data-count">
                      {(() => {
                        const economyKeys = Object.keys(localStorage).filter(key => key.startsWith('economy_'));
                        const mainEconomy = JSON.parse(localStorage.getItem('economy') || '{}');
                        return economyKeys.length + Object.keys(mainEconomy).length;
                      })()} kayıt
                    </span>
                  </div>
                </div>
              </div>

              <div className="settings-section">
                <h3>⚠️ Tehlikeli İşlemler</h3>
                <div className="settings-actions">
                  <button className="danger-btn" onClick={resetAllSystemData}>
                    💥 TÜM SİSTEM VERİLERİNİ SİFIRLA
                  </button>
                  <p style={{fontSize: '14px', color: '#ff4444', marginTop: '10px'}}>
                    ⚠️ Tüm geçmiş verileri sil - Sadece öğrenci listesi ve doğum günleri korunur
                  </p>
                </div>
              </div>

              {manualSendStatus && (
                <div className="manual-send-status" style={{
                  background: '#e8f5e8',
                  border: '1px solid #4caf50',
                  borderRadius: '8px',
                  padding: '15px',
                  marginTop: '20px',
                  color: '#2e7d32'
                }}>
                  <p>{manualSendStatus}</p>
                </div>
              )}
            </div>
          )}

          {activeTab === 'reports' && (
            <ReportsView 
              students={students}
              behaviors={behaviors}
              behaviorIssues={behaviorIssues}
              economy={economy}
            />
          )}

          {activeTab === 'behaviors' && (
            <div className="behaviors-management">
              <div className="add-behavior-form">
                <h3>{editingBehavior ? 'Davranış Düzenle' : 'Yeni Davranış Ekle'}</h3>
                <div className="form-grid">
                  <input
                    type="text"
                    placeholder="Davranış Kodu (D04, D05, vb.)"
                    value={behaviorForm.code}
                    onChange={(e) => setBehaviorForm({...behaviorForm, code: e.target.value.toUpperCase()})}
                  />
                  <input
                    type="text"
                    placeholder="Davranış Açıklaması"
                    value={behaviorForm.description}
                    onChange={(e) => setBehaviorForm({...behaviorForm, description: e.target.value})}
                  />
                  <input
                    type="number"
                    placeholder="Ceza Puanı (varsayılan: 3)"
                    value={behaviorForm.penalty}
                    onChange={(e) => setBehaviorForm({...behaviorForm, penalty: parseInt(e.target.value) || 3})}
                    min="1"
                    max="20"
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                  <select
                    value={behaviorForm.type}
                    onChange={(e) => setBehaviorForm({...behaviorForm, type: e.target.value})}
                  >
                    <option value="daily_count">Günlük Sayım</option>
                    <option value="serious_incident">Ciddi Olay</option>
                  </select>
                </div>
                <div className="form-buttons">
                  {editingBehavior ? (
                    <>
                      <button className="update-btn" onClick={() => {
                        if (!behaviorForm.code || !behaviorForm.description) {
                          alert('Kod ve açıklama zorunludur!');
                          return;
                        }
                        
                        const customBehaviors = JSON.parse(localStorage.getItem('customBehaviors') || '[]');
                        const updatedBehaviors = customBehaviors.map(behavior => 
                          behavior.code === editingBehavior 
                            ? { ...behaviorForm }
                            : behavior
                        );
                        localStorage.setItem('customBehaviors', JSON.stringify(updatedBehaviors));
                        
                        setEditingBehavior(null);
                        setBehaviorForm({ code: '', description: '', penalty: 3, type: 'daily_count' });
                        setBehaviorForceUpdate(prev => prev + 1);
                        alert('Davranış güncellendi!');
                      }}>Güncelle</button>
                      <button className="cancel-btn" onClick={() => {
                        setEditingBehavior(null);
                        setBehaviorForm({ code: '', description: '', penalty: 3, type: 'daily_count' });
                      }}>İptal</button>
                    </>
                  ) : (
                    <button className="add-btn" onClick={() => {
                      if (!behaviorForm.code || !behaviorForm.description) {
                        alert('Kod ve açıklama zorunludur!');
                        return;
                      }
                      
                      const customBehaviors = JSON.parse(localStorage.getItem('customBehaviors') || '[]');
                      
                      // Duplicate kontrol
                      if (customBehaviors.some(b => b.code === behaviorForm.code)) {
                        alert('Bu davranış kodu zaten mevcut!');
                        return;
                      }
                      
                      customBehaviors.push({ ...behaviorForm });
                      localStorage.setItem('customBehaviors', JSON.stringify(customBehaviors));
                      
                      setBehaviorForm({ code: '', description: '', penalty: 3, type: 'daily_count' });
                      setBehaviorForceUpdate(prev => prev + 1);
                      alert('Davranış eklendi!');
                    }}>Ekle</button>
                  )}
                </div>
              </div>

              <div className="behaviors-list">
                <h3>📋 Tüm Davranış Kodları</h3>
                
                {/* Default Davranışlar */}
                <div className="behavior-section">
                  <h4>🔒 Sistem Davranışları (Değiştirilemez)</h4>
                  <div className="behaviors-grid default">
                    {behaviorIssues.map((behavior) => {
                      // Bu davranışın kullanım istatistiklerini hesapla
                      const behaviorData = JSON.parse(localStorage.getItem('behaviors') || '{}');
                      let totalUsage = 0;
                      let todayUsage = 0;
                      const today = new Date().toISOString().split('T')[0];
                      
                      Object.keys(behaviorData).forEach(key => {
                        if (key.includes(`-${behavior.code}-`)) {
                          const count = behaviorData[key] || 0;
                          totalUsage += count;
                          if (key.endsWith(`-${today}`)) {
                            todayUsage += count;
                          }
                        }
                      });
                      
                      return (
                        <div key={behavior.code} className="behavior-card default">
                          <div className="behavior-header">
                            <span className="behavior-code default">{behavior.code}</span>
                            <span className="behavior-type">{behavior.type === 'serious_incident' ? '🚨 Ciddi' : '📊 Günlük'}</span>
                          </div>
                          <div className="behavior-info">
                            <p className="behavior-desc">{behavior.description}</p>
                            <div className="behavior-stats">
                              <span className="stat-item">💰 Ceza: {behavior.code === 'D01' ? '10' : behavior.code === 'D02' ? '8' : behavior.code === 'D03' ? '5' : '3'}₺</span>
                              <span className="stat-item">📈 Toplam: {totalUsage}</span>
                              <span className="stat-item">📅 Bugün: {todayUsage}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                
                {/* Custom Davranışlar */}
                <div className="behavior-section">
                  <h4>🔧 Özel Davranışlar ({JSON.parse(localStorage.getItem('customBehaviors') || '[]').length}) {behaviorForceUpdate > 0 && ''}</h4>
                  <div className="behaviors-grid custom" key={behaviorForceUpdate}>
                    {JSON.parse(localStorage.getItem('customBehaviors') || '[]').map((behavior) => {
                      // Bu davranışın kullanım istatistiklerini hesapla
                      const behaviorData = JSON.parse(localStorage.getItem('behaviors') || '{}');
                      let totalUsage = 0;
                      let todayUsage = 0;
                      const today = new Date().toISOString().split('T')[0];
                      
                      Object.keys(behaviorData).forEach(key => {
                        if (key.includes(`-${behavior.code}-`)) {
                          const count = behaviorData[key] || 0;
                          totalUsage += count;
                          if (key.endsWith(`-${today}`)) {
                            todayUsage += count;
                          }
                        }
                      });
                      
                      return (
                        <div key={behavior.code} className="behavior-card custom">
                          <div className="behavior-header">
                            <span className="behavior-code custom">{behavior.code}</span>
                            <span className="behavior-type">{behavior.type === 'serious_incident' ? '🚨 Ciddi' : '📊 Günlük'}</span>
                          </div>
                          <div className="behavior-info">
                            <p className="behavior-desc">{behavior.description}</p>
                            <div className="behavior-stats">
                              <span className="stat-item">💰 Ceza: {behavior.penalty}₺</span>
                              <span className="stat-item">📈 Toplam: {totalUsage}</span>
                              <span className="stat-item">📅 Bugün: {todayUsage}</span>
                            </div>
                          </div>
                          <div className="behavior-actions">
                            <button className="edit-btn" onClick={() => {
                              setEditingBehavior(behavior.code);
                              setBehaviorForm({ ...behavior });
                            }}>✏️ Düzenle</button>
                            <button className="delete-btn" onClick={() => {
                              if (window.confirm(`"${behavior.code} - ${behavior.description}" davranışını silmek istediğinizden emin misiniz?\n\n⚠️ Bu davranışla ilgili tüm kayıtlar da silinecek!`)) {
                                const customBehaviors = JSON.parse(localStorage.getItem('customBehaviors') || '[]');
                                const updatedBehaviors = customBehaviors.filter(b => b.code !== behavior.code);
                                
                                // Bu davranışla ilgili tüm kayıtları sil
                                const behaviors = JSON.parse(localStorage.getItem('behaviors') || '{}');
                                const updatedBehaviorRecords = {};
                                Object.keys(behaviors).forEach(key => {
                                  if (!key.includes(`-${behavior.code}-`)) {
                                    updatedBehaviorRecords[key] = behaviors[key];
                                  }
                                });
                                
                                localStorage.setItem('customBehaviors', JSON.stringify(updatedBehaviors));
                                localStorage.setItem('behaviors', JSON.stringify(updatedBehaviorRecords));
                                setBehaviorForceUpdate(prev => prev + 1);
                                
                                alert('Davranış ve ilgili kayıtlar silindi!');
                              }
                            }}>🗑️ Sil</button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {JSON.parse(localStorage.getItem('customBehaviors') || '[]').length === 0 && (
                    <div className="no-behaviors">
                      <p>🔧 Henüz özel davranış eklenmemiş.</p>
                      <p>Yukarıdaki formu kullanarak yeni davranış kodları ekleyebilirsiniz.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'birthdays' && (
            <div className="birthdays-management">
              <BirthdayManager />
            </div>
          )}

          {activeTab === 'telegram' && (
            <div className="telegram-management">
              <TelegramTest />
            </div>
          )}
        </div>
        

      </div>
    </div>
  );
};

export default AdminPanel;